// A pizza da cobertura no bloco de estado (design D3): o valor de referência da obra dividido
// em pela origem (físico-financeiro ou origem gravada), pelas regras e sem distribuição. Lê
// SÓ as partes que a geração gravou (`coverageParts`) — as mesmas que a lista de números do
// `ProjectedCoverage` mostra aqui e no cartão da Projeção Financeira.
//
// Os callbacks do chart.js rodam fora do render do React: o rótulo do tooltip vem pronto
// (`partText`, puro), sem hook nenhum.
import { Doughnut } from "react-chartjs-2";
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from "chart.js";

import {
  PHYSICAL_COLOR,
  RESULTING_COLOR,
  UNDISTRIBUTED_COLOR,
} from "./chartColors";
import { coverageParts } from "./coverage";
import { partText } from "./ProjectedCoverage";

ChartJS.register(ArcElement, Tooltip, Legend);

// As mesmas cores do gráfico do topo: a origem na cor da linha do físico-financeiro/previsto e
// as regras na cor das barras do desembolso resultante.
export const PART_COLORS = Object.freeze({
  origin: PHYSICAL_COLOR,
  ruled: RESULTING_COLOR,
  undistributed: UNDISTRIBUTED_COLOR,
});

const CoverageDoughnut = ({ coverage }) => {
  const parts = coverageParts(coverage);
  if (!parts || !parts.some((part) => part.cents > 0)) return null;
  const texts = parts.map(partText);
  const data = {
    labels: parts.map((part) => part.label),
    datasets: [
      {
        data: parts.map((part) => (part.cents ?? 0) / 100),
        backgroundColor: parts.map((part) => PART_COLORS[part.key]),
        borderWidth: 0,
      },
    ],
  };
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "62%",
    plugins: {
      // A plataforma registra `chartjs-plugin-datalabels` globalmente.
      datalabels: { display: false },
      // A legenda é a lista de partes ao lado (com valor e percentual), não a do canvas.
      legend: { display: false },
      tooltip: { callbacks: { label: (item) => texts[item.dataIndex] } },
    },
  };
  return (
    <figure className="ampli-coverage-doughnut" data-testid="coverage-doughnut">
      <div
        className="ampli-coverage-doughnut__canvas"
        role="img"
        aria-label={`Divisão do valor de referência: ${texts.join("; ")}`}
      >
        <Doughnut data={data} options={options} />
      </div>
      <figcaption className="visually-hidden">Divisão do valor de referência da obra</figcaption>
    </figure>
  );
};

export default CoverageDoughnut;
